import { Row, Col, Button, Popover, notification } from 'antd';
import React, { useEffect, useState } from 'react';
import copy from 'copy-to-clipboard';
import { capitalize } from '../../utils/common';
import './LocationInfo.scss';
import { ReactSVG } from 'react-svg';

const LocationInfo = ({ location = {}, onClickEdit }) => {
  const [status, setStatus] = useState('Active');
  const [times, setTimes] = useState([]);
  useEffect(() => {
    if (location?.pickupHours) {
      const newTimes = [];
      setStatus(location.isActive ? 'Active' : 'Inactive');
      Object.keys(location.pickupHours).forEach((key) => {
        if (location.pickupHours[key].start || location.pickupHours[key].end) {
          newTimes.push({
            label: key,
            start: location.pickupHours[key].start || '',
            end: location.pickupHours[key].end || '',
          });
        }
      });
      setTimes(newTimes);
    }
  }, [location]);

  const onClickCopy = (value) => {
    copy(value);
    notification.success({ message: 'Copied' });
  };
  const getStringAddress = (address) =>
    `${address.street} ${address.houseNumber}, ${address.postalCode} ${address.city}, ${address.countryCode}`;

  return (
    <div className="LocationInfo">
      <Row gutter={16}>
        <Col span={16}>
          <div className="content">
            <h4>{location.name}</h4>
            <div className="id">
              {location.locationId && (
                <div onClick={() => onClickCopy(location.locationId)}>
                  {location.locationId}
                  <img src="/icons/file_copy.svg" />
                </div>
              )}
              <p>
                [{location.locationType}] {location.region}
              </p>
            </div>
            <Popover content={getStringAddress(location.address)}>
              <p>
                {getStringAddress(location.address).length > 45
                  ? getStringAddress(location.address).substring(0, 45) + '...'
                  : getStringAddress(location.address)}
              </p>
            </Popover>
            <p>{location.contactPerson}</p>
            <p>{location.phone}</p>
            {times?.length > 0 &&
              times.map((time) => (
                <div key={time.label + location.id} className="pickup-time">
                  <p className="label">{capitalize(time.label)}</p>
                  <p className="content">
                    {time.start} {' - '} {time.end}
                  </p>
                </div>
              ))}
          </div>
        </Col>
        <Col span={8}>
          <div className="right">
            <span className={'status companies ' + status.toLowerCase()}>{status}</span>
            <div className="actions">
              {onClickEdit && (
                <Button type="link" className="edit" onClick={onClickEdit}>
                  <ReactSVG className="icon" src="/icons/edit.svg" />
                </Button>
              )}
              {/* <Button type="link" className="more">
                <ReactSVG className="icon" src="/icons/more.svg" />
              </Button> */}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default LocationInfo;
